import React from "react"
import CtxHeroSection from "../../../common/sections/ctx-hero-section/CtxHeroSection"
import TitleTagsHeaderBlock from "../../blocks/title-tags-header/TitleTagsHeaderBlock"

function FrontPageHeaderSection({
  imageAlt,
  imageUrl,
  articles,
  title,
  isTagPage,
}) {
  return (
    <CtxHeroSection
      imgSrc={imageUrl}
      imgAlt={imageAlt}
      classes="mb-5 pb-8"
    >
      <TitleTagsHeaderBlock
        articles={articles}
        Title={title}
        isTagPage={isTagPage}
      />
    </CtxHeroSection>
  )
}
export const name = "FrontPageHeaderSection"

export const init = (componentData, pageContext) => {
  return (
    <FrontPageHeaderSection
      key={componentData.id}
      imageAlt={
        componentData?.data?.headerImage?.data?.attributes.alternativeText
      }
      isTagPage={componentData.isTagHeader}
      imageUrl={componentData.headerImage?.data?.attributes?.url}
      articles={pageContext.articlesData}
      title={
        pageContext?.itemData?.attributes.label
          ? pageContext.itemData.attributes.label
          : pageContext.pageData.attributes.label
      }
    />
  )
}
export default FrontPageHeaderSection
